import * as roles from '../constants/roles';
import { User } from '../types/user';

function includes(userRoles, role) {
  return userRoles ? userRoles.indexOf(role) !== -1 : false;
}

function getUserRoles(user) {
  return user?.details?.roles || user?.roles || [];
}

function isOneOf(user, rolesArray) {
  const userRoles = getUserRoles(user);
  return rolesArray.reduce((initial, role) => includes(userRoles, role) || initial, false);
}

export function isEmployee(user) {
  return isOneOf(user, [
    roles.EMPLOYEE, roles.GOD_EMPLOYEE
  ]);
}
  
export function isPartner(user) {
  return isOneOf(user, [
    roles.DEALER_REP, roles.DEALER_LOC_ADMIN
  ]);
}

export function isDealerRep(user: User) {
  const userRoles = getUserRoles(user);
  return includes(userRoles, roles.DEALER_REP);
}